import React, { useState, useEffect } from "react";
import axiosClient from "../utils/axiosClient";
import { API_BASE_URL } from "../utils/urls";

export default function ConnectStripePage() {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  // Load user from localStorage (Web Version)
  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) setUser(JSON.parse(savedUser));
  }, []);

  const handleConnectStripe = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const response = await axiosClient.get("/stripe/connect", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.data.url) {
        alert("Unable to get Stripe Connect URL.");
        return;
      }

      // ⬅ Redirect the browser to Stripe Connect onboarding URL
      window.location.href = response.data.url;

    } catch (err) {
      console.error("Stripe Connect error:", err);
      alert("Failed to create Stripe connect session.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-6">
      {/* Title */}
      <h1 className="text-3xl font-bold text-gray-800 mb-3">
        Connect Your Stripe Account
      </h1>

      {/* Subtitle */}
      <p className="text-gray-600 text-center max-w-md mb-6">
        Connect your Stripe account to receive payments for your clients and invoices securely.
      </p>

      {/* Connect Button */}
      <button
        onClick={handleConnectStripe}
        disabled={loading}
        className={`bg-indigo-600 text-white px-6 py-3 rounded-lg shadow-md text-lg font-semibold hover:bg-indigo-700 transition ${
          loading ? "opacity-70 cursor-not-allowed" : ""
        }`}
      >
        {loading ? "Connecting..." : "Connect with Stripe"}
      </button>

      {/* Optional Info */}
      {user?.organization_id && (
        <p className="text-gray-500 mt-4">
          Organization ID: <span className="font-medium">{user.organization_id}</span>
        </p>
      )}
    </div>
  );
}
